import React from 'react';
import Icon from '../../../components/AppIcon';

const GapAnalysisSection = ({ currentValue, targetValue, metric, unit }) => {
  const progress = Math.min((currentValue / targetValue) * 100, 100);
  const gap = targetValue - currentValue;
  const gapPercentage = ((gap / targetValue) * 100)?.toFixed(1);

  return (
    <div className="bg-card rounded-xl border border-border p-6 md:p-8 elevation-sm">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-secondary/20 flex items-center justify-center">
          <Icon name="BarChart3" size={20} color="var(--color-secondary)" />
        </div>
        <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Gap Analysis
        </h3>
      </div>
      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="p-4 bg-muted/50 rounded-lg">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Activity" size={16} color="var(--color-muted-foreground)" />
              <span className="text-xs text-muted-foreground font-caption">Current</span>
            </div>
            <div className="text-xl md:text-2xl font-heading font-bold text-foreground">
              {unit}{currentValue?.toLocaleString()}
            </div>
          </div>

          <div className="p-4 bg-primary/10 rounded-lg border border-primary/20">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Target" size={16} color="var(--color-primary)" />
              <span className="text-xs text-primary font-caption">Target</span>
            </div>
            <div className="text-xl md:text-2xl font-heading font-bold text-primary">
              {unit}{targetValue?.toLocaleString()}
            </div>
          </div>

          <div className="p-4 bg-warning/10 rounded-lg border border-warning/20">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="AlertCircle" size={16} color="var(--color-warning)" />
              <span className="text-xs text-warning font-caption">Gap</span>
            </div>
            <div className="text-xl md:text-2xl font-heading font-bold text-warning">
              {unit}{gap?.toLocaleString()}
            </div>
          </div>
        </div>

        <div>
          <div className="flex items-center justify-between mb-3">
            <span className="text-sm font-medium text-foreground font-body">
              Progress to Goal
            </span>
            <span className="text-sm font-medium text-primary font-body">
              {progress?.toFixed(1)}%
            </span>
          </div>
          <div className="h-3 bg-muted rounded-full overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-primary to-secondary transition-smooth"
              style={{ width: `${progress}%` }}
            />
          </div>
          <p className="text-xs text-muted-foreground font-caption mt-2">
            You need to achieve {gapPercentage}% more to reach your target
          </p>
        </div>

        <div className="p-4 bg-accent/10 border border-accent/20 rounded-lg">
          <div className="flex items-start gap-3">
            <Icon name="Lightbulb" size={18} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm font-medium text-foreground font-body mb-1">
                AI Recommendation
              </p>
              <p className="text-sm text-muted-foreground font-body">
                To close this gap, focus on increasing {metric?.toLowerCase()} by approximately{' '}
                {((gap / (parseInt(unit === '$' ? '12' : '4'))) / 1000)?.toFixed(1)}K per{' '}
                {unit === '$' ? 'month' : 'quarter'}. Consider optimizing your top revenue channels and reducing operational costs.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GapAnalysisSection;